import React from 'react';
import { Globe2Icon, InstagramIcon, MailIcon } from 'lucide-react';
export function Footer() {
  return <footer className="bg-[#140c16] px-5 py-14 text-center" data-id="element-71" data-mp="3gfiu2hdxs9dl">
      <div className="mx-auto max-w-4xl" data-id="element-72" data-mp="3gh3n22klrk9c">
        <p className="font-display text-3xl font-bold uppercase tracking-wide text-emerald-300" data-id="element-73" data-mp="32ovwwtntqrjm">
          PILATES PRONTA™
        </p>
        <p className="mt-3 font-bold text-white" data-id="element-74" data-mp="36ppn5toqoifo">
          Il sistema completo per le insegnanti di Pilates.
        </p>
        <p className="mt-2 text-sm italic text-slate-300" data-id="element-75" data-mp="38qvoyiyxrr6">
          Perché insegnare Pilates non dovrebbe costarti ogni sera della
          settimana.
        </p>
        <div className="mx-auto mt-8 flex max-w-xl flex-wrap justify-center gap-x-6 gap-y-3 border-y border-emerald-300/20 py-6 text-sm font-semibold text-slate-300" data-id="element-76" data-mp="3ldu34pweqfur">
          <a className="flex items-center gap-2 hover:text-white" href="mailto:support.peready360@gmail.com" data-id="element-77" data-mp="29yxc5agnxgkr">
            <MailIcon className="h-4 w-4 text-emerald-300" data-id="element-78" data-mp="2ew6yuico3e4w" />
            supporto via email
          </a>
          <a className="flex items-center gap-2 hover:text-white" href="https://instagram.com/peready360" data-id="element-79" data-mp="3lbmvrwv0jgi0">
            <InstagramIcon className="h-4 w-4 text-emerald-300" data-id="element-80" data-mp="3v7zx9gwsuynb" />
            Seguici su Instagram
          </a>
          <a className="flex items-center gap-2 hover:text-white" href="https://www.peready360.com" data-id="element-81" data-mp="3q7llbns2v4k0">
            <Globe2Icon className="h-4 w-4 text-emerald-300" data-id="element-82" data-mp="80xi63gl8rgz" />
            Sito ufficiale
          </a>
        </div>
        <p className="mt-8 text-[10px] font-bold uppercase tracking-widest text-slate-500" data-id="element-83" data-mp="hstuojjf8k4q">
          PILATES PRONTA™ — Docenti Elite · © 2026 — Tutti i diritti
          riservati.
        </p>
      </div>
    </footer>;
}